import React, { useEffect, useState } from "react";
import { Loader2, Save, ShieldCheck } from "lucide-react";
import { toast } from "sonner";
import { getPlatformSettings, savePlatformSettings } from "../../lib/api";

export function MetaSettingsCard() {
  const [settings, setSettings] = useState(null);
  const [form, setForm] = useState({ meta_access_token: "", meta_ad_account_id: "", meta_page_id: "" });
  const [saving, setSaving] = useState(false);

  const load = async () => {
    const data = await getPlatformSettings();
    setSettings(data);
    setForm((f) => ({ ...f, meta_ad_account_id: data.meta_ad_account_id || "", meta_page_id: data.meta_page_id || "" }));
  };
  useEffect(() => { load(); }, []);

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const payload = { meta_ad_account_id: form.meta_ad_account_id, meta_page_id: form.meta_page_id };
      if (form.meta_access_token.trim()) payload.meta_access_token = form.meta_access_token.trim();
      await savePlatformSettings(payload);
      toast.success("Meta connection saved.");
      setForm((f) => ({ ...f, meta_access_token: "" }));
      load();
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Could not save.");
    } finally { setSaving(false); }
  };

  return (
    <div className="border border-sand/70 bg-bone rounded-md px-5 py-5" data-testid="admin-meta-settings">
      <div className="flex items-center justify-between gap-3">
        <p className="flex items-center gap-2 text-[10px] tracking-[0.22em] uppercase text-mocha"><ShieldCheck size={13} /> Meta connection</p>
        <span className={`text-[10px] tracking-[0.12em] uppercase px-2 py-0.5 rounded border ${settings?.meta_connected ? "border-burgundy text-burgundy" : "border-sand text-mocha"}`} data-testid="admin-meta-status">{settings?.meta_connected ? "Stored" : "Not set"}</span>
      </div>
      <p className="mt-2 text-xs text-ink/50">Stored securely. Ads won't publish automatically yet — this just connects your account for when you're ready to spend.</p>
      <form onSubmit={save} className="mt-4 space-y-3" data-testid="admin-meta-form">
        <label className="block">
          <span className="block text-[11px] text-ink/55 mb-1">Access token {settings?.meta_access_token_masked && <span className="text-ink/35">· saved {settings.meta_access_token_masked}</span>}</span>
          <input type="password" value={form.meta_access_token} onChange={set("meta_access_token")} placeholder={settings?.meta_connected ? "•••••• (leave blank to keep)" : "EAAG…"} className="w-full border border-sand rounded-md px-3 py-2 text-sm bg-bone outline-none focus:border-espresso" data-testid="admin-meta-token" />
        </label>
        <div className="grid grid-cols-2 gap-3">
          <label className="block">
            <span className="block text-[11px] text-ink/55 mb-1">Ad account ID</span>
            <input type="text" value={form.meta_ad_account_id} onChange={set("meta_ad_account_id")} placeholder="act_1234567890" className="w-full border border-sand rounded-md px-3 py-2 text-sm bg-bone outline-none focus:border-espresso" data-testid="admin-meta-ad-account" />
          </label>
          <label className="block">
            <span className="block text-[11px] text-ink/55 mb-1">Page ID</span>
            <input type="text" value={form.meta_page_id} onChange={set("meta_page_id")} placeholder="1098…" className="w-full border border-sand rounded-md px-3 py-2 text-sm bg-bone outline-none focus:border-espresso" data-testid="admin-meta-page" />
          </label>
        </div>
        <button type="submit" disabled={saving} className="inline-flex items-center gap-2 rounded-full bg-espresso text-bone px-5 py-2.5 text-sm hover:bg-ink disabled:opacity-60 transition-colors" data-testid="admin-meta-save">
          {saving ? <Loader2 size={14} className="animate-spin" /> : <Save size={14} />} Save connection
        </button>
      </form>
    </div>
  );
}
